import { withNamespaces } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    Button,
    Card,
    CardBody,
} from 'reactstrap';

import { ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST } from 'src/modules/3rd-party-management/constants';
import { AttentionItemTypes } from '../constants';

const NeedsYourAttention = ({
    items = [],
    t,
}) => {
    const history = useHistory();

    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                    <h6 className="mb-0">
                        {t('Needs Your Attention')}
                        <span className="badge bg-danger rounded-pill ms-2">
                            {items.length}
                        </span>
                    </h6>

                    <Button
                        className="p-0"
                        color="link"
                        onClick={() => history.push(ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST)}
                        type="button"
                    >
                        {t('View all')}
                        <i className="ri-arrow-right-line align-middle ms-1" />
                    </Button>
                </div>

                <ul className="list-unstyled mb-0">
                    {items.map((item) => {
                        const itemInfos = AttentionItemTypes[item.type];

                        return (
                            <li className="border rounded p-2 mb-2" key={item.id}>
                                <div className="d-flex align-items-center">
                                    <div className="avatar-xs me-2">
                                        <span className={`avatar-title rounded-circle bg-soft-${itemInfos.color} text-${itemInfos.color}`}>
                                            <i className={itemInfos.icon} />
                                        </span>
                                    </div>

                                    <div className="flex-grow-1">
                                        <span className="d-block fw-medium">
                                            {t(item.title)}
                                        </span>

                                        <small className="text-muted">
                                            {t(item.description)}
                                        </small>
                                    </div>

                                    <i className="ri-arrow-right-s-line text-muted font-size-18" />
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    NeedsYourAttention
);
